class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    // Der Schliessen-Knopf im Modal (snippets/nav-drawer-search.liquid,
    // snippets/header-search.liquid). Abgesichert, weil DetailsModal auch
    // von PasswordModal beerbt wird (assets/password-modal.js) und dessen
    // Markup diesen Knopf nicht zwingend mitbringt.
    this.closeButton = this.querySelector('button[type="button"]');
    this.onBodyClickEvent = this.onBodyClick.bind(this);

    // Diese drei Wege zum Schliessen waren auskommentiert. Das Modal
    // (.modal__content) liegt mit position:absolute und top/left/right/
    // bottom:0 ueber dem Header und verdeckt dabei die Lupe, mit der man es
    // geoeffnet hat — ein zweiter Klick darauf kam also gar nicht mehr an.
    // Zusammen mit dem leeren close() gab es damit ueberhaupt keine
    // Moeglichkeit mehr, die Suche wieder zuzubekommen.
    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    if (this.closeButton) this.closeButton.addEventListener('click', this.close.bind(this));

    // Klick neben das Modal schliesst ebenfalls. Bewusst am toggle-Ereignis
    // des <details> aufgehaengt und nicht in open(): das Oeffnen laeuft in
    // diesem Theme ueber das native Aufklappen des <details> (der
    // Klick-Listener auf der summary ist nicht aktiv), open() wird dabei
    // also nie durchlaufen. Das toggle-Ereignis feuert in einer eigenen
    // Task, nachdem der oeffnende Klick fertig durchs DOM gelaufen ist —
    // der Listener faengt diesen Klick daher nicht mehr ab und schliesst
    // das Modal nicht sofort wieder.
    this.detailsContainer.addEventListener('toggle', this.onToggle.bind(this));
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onToggle() {
    if (this.isOpen()) {
      document.body.addEventListener('click', this.onBodyClickEvent);
    } else {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
